import Button from '@components/Button';
import Column from '@components/Column';
import Text from '@components/Text';
import styled from '@emotion/styled';
import useUser from '@hooks/auth/useUser';
import PlusCircleLine from '@icons/PlusCircleLine';
import { Link } from '@stackflow/link';
import { Fragment } from 'react';
import { Trans, useTranslation } from 'react-i18next';

function LoginCard() {
    const { t } = useTranslation('main', { keyPrefix: 'login' });
    const { user, isLoading } = useUser();
    const loginVisible = !isLoading && !user;
    if (loginVisible) {
        return (
            <Container align='center' spacing={2}>
                <Comment size='body-long' align='center'>
                    <Trans ns='main' i18nKey='login.comment' components={{ br: <br/> }} />
                </Comment>
                <Link activityParams={{}}
                    activityName='SignInActivity' >
                    <LoginButton size='xsmall'>
                        <PlusCircleLine/>
                        {t('button')}
                    </LoginButton>
                </Link>
            </Container>
        );
    }
    return (<Fragment/>);
}

const Container = styled(Column)`
    background-color: var(--color-white);
    border-radius: 8px;
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.10);
    margin: 0 auto var(--spacing-12);
    max-width: calc(100% - var(--spacing-8));
    padding: var(--spacing-6) var(--spacing-4);
    width: calc(100% - var(--spacing-8));
`;

const LoginButton = styled(Button)`
    column-gap: var(--spacing-2);
    font-weight: 500;
    min-height: var(--spacing-8);
    padding-left: var(--spacing-6) !important;
    padding-right: var(--spacing-6) !important;
`;

const Comment = styled(Text)`
    color: var(--color-text-primary);
`;

export default LoginCard;
